import { render, staticRenderFns } from "./AdminUnit.vue?vue&type=template&id=ea2e0d88&"
import script from "./AdminUnit.vue?vue&type=script&lang=js&"
export * from "./AdminUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports